export default from './ChatPage';



// WEBPACK FOOTER //
// ./src/pages/chat/index.js